<template>
  <div class="main">
    <div class="mine_body flex">
      <MineBodyLeftMenu :menu="this.menu" />
      <div v-if="this.menu == 'profile'" class="flex_item">
        <MineBodyProfile />
      </div>
      <div v-if="this.menu == 'class'" class="flex_item">
        <MineBodyCourse />
      </div>
      <div v-if="this.menu == 'order'" class="flex_item">
        <MineBodyOrder />
      </div>
      <div v-if="this.menu == 'point'" class="flex_item">
        <MineBodyPoint />
      </div>
      <div v-if="this.menu == 'receipt'" class="flex_item">
        <MineBodyReceipt />
      </div>
    </div>
  </div>
</template>

<script>
import MineBodyLeftMenu from "@/components/UserCenter/MineBodyLeftMenu";
import MineBodyProfile from "@/components/UserCenter/MineBodyProfile";
import MineBodyCourse from "@/components/UserCenter/MineBodyCourse";
import MineBodyOrder from "@/components/UserCenter/MineBodyOrder";
import MineBodyPoint from "@/components/UserCenter/MineBodyPoint";
import MineBodyReceipt from "@/components/UserCenter/MineBodyReceipt";

export default {
  components: {
    MineBodyLeftMenu,
    MineBodyProfile,
    MineBodyCourse,
    MineBodyOrder,
    MineBodyPoint,
    MineBodyReceipt
  },
  props: {
    menu: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.main {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  min-width: 1200px;
}
d .mine_body {
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  align-items: flex-start;
}
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: top;
}
.flex_item {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  min-width: 0;
}
</style>